import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule],
})
export class TooltipComponent {
    @Input() showInfoTooltip: boolean = false;
    @Input() position: string = 'top';

    @Input() tooltipData: any = {
        header: '',
        content: '',
        content2: '',
        content3: ''
    };
}
